import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector     : 'faq-answer',
    templateUrl  : './answer.component.html',
    styleUrls    : ['./answer.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FaqAnswerComponent
{
    /**
     * Constructor
     *
     * @param {MatDialogRef<FaqAnswerComponent>} matDialogRef
     * @param _data
     */
    constructor(
        public matDialogRef: MatDialogRef<FaqAnswerComponent>,
        @Inject(MAT_DIALOG_DATA) public _data: any
    )
    {
    }
}